import { createSelector } from 'reselect';

export interface CollectionsState {
  collections: any[];
  loading: boolean;
  editCollection: any;
}

export const initialState: CollectionsState = {
  collections: [],
  loading: false,
  editCollection: null,
};

const getCollections = ({ collections }: any): CollectionsState => collections;

export const collectionsSelectors = {
  getCollections: createSelector(
    getCollections,
    ({ collections }) => collections,
  ),

  getLoading: createSelector(
    getCollections,
    ({ loading }) => loading,
  ),

  getEditCollection: createSelector(
    getCollections,
    ({ editCollection }) => editCollection,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Collections/services/selectors.ts